import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a0c36e98"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ambient ambient-left"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ambient ambient-right"
}, null, -1));
const _hoisted_3 = {
  class: "app-main"
};
const _hoisted_4 = {
  class: "site-layout"
};
const _hoisted_5 = {
  class: "page-shell"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("footer", {
  class: "site-footer",
  "aria-label": "网站备案信息"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "site-footer-inner"
}, [/*#__PURE__*/_createElementVNode("span", null, "songbao.vip"), /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "·"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank",
  rel: "noopener noreferrer"
}, " 黔ICP备2025047273号-1 ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_navigation = _resolveComponent("top-navigation");
  const _component_router_view = _resolveComponent("router-view");
  const _component_global_music_player = _resolveComponent("global-music-player");
  const _component_page_scroll_rope = _resolveComponent("page-scroll-rope");
  const _component_app_feedback = _resolveComponent("app-feedback");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-shell", {
      'magazine-route': $options.isMagazineRoute,
      'studio-route': $options.isStudioRoute,
      'music-route': $options.isMusicRoute
    }])
  }, [_hoisted_1, _hoisted_2, _createVNode(_component_top_navigation), _createElementVNode("main", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)])])]), _hoisted_6, _createVNode(_component_global_music_player), $options.showArticleScrollRope ? (_openBlock(), _createBlock(_component_page_scroll_rope, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_app_feedback)], 2);
}